<template>
  <div class="custom-tree">
    <el-input v-model="searchKeyword" placeholder="请输入城市名称" size="small" clearable style="margin-bottom: 8px;"
      @keyup.enter.native="onSearch">
      <template slot="append">
        <div @click="onSearch">
          <i slot="suffix" class="el-icon-search"></i>
        </div>
      </template>
    </el-input>
    <div class="tree-list scrollBar-custom">
      <ul class="tree-list-content">
        <li v-for="province in filteredTreeData" :key="province.provinceName" class="province"
          @click="selectCity(province)" :class="{ active: province.cityCode == selectedCityKey }" :style="{ cursor: province.children ? '' : 'pointer'}">
          <span class="province-name">{{ province.provinceName }}</span>
          <ul>
            <li v-for="city in province.children" :key="city.cityCode" class="city"
              :class="{ active: city.cityCode == selectedCityKey }" @click="selectCity(city)">
              {{ city.cityName }}
            </li>
          </ul>
        </li>
      </ul>
      <div class="tree-btn">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 带搜索的树形城市选择组件
 * @module CustomTree
 */
export default {
  name: 'CustomCityTree',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      treeData: [],
      searchKeyword: '',
      selectedCityKey: null,
      filteredTreeData: []
    }
  },
  created() {
    /**
     * 初始化时默认选中第一项
     * 如果第一项有children，则选中其第一个子项
     * 否则选中第一项本身
     */
    this.getCityData()
  },
  computed: {
  },
  methods: {
    onSearch() {
      this.filteredTreeData = this.searchData()
    },
    searchData() {
      if (!this.searchKeyword) return this.treeData
      const keyword = this.searchKeyword.trim()
      // 过滤逻辑：如果当前项没有children，则直接匹配当前项
      return this.treeData
        .map(province => {
          // 如果没有children，直接匹配province本身
          if (!province.children || !province.children.length) {
            return province.provinceName.includes(keyword) ? province : null
          }
          // 有children的情况，匹配children
          const matchedCities = province.children.filter(city =>
            city.cityName.includes(keyword)
          )
          if (matchedCities.length > 0) {
            return {
              ...province,
              children: matchedCities
            }
          }
          return null
        })
        .filter(Boolean)
    },
    async getCityData(isrefresh = false) {
      const { code, data } = await this.$axios.get(this.url)
      if (code === 1) {
        this.treeData = this.$utils.groupByToArray(data, 'provinceName')
        if (this.treeData && this.treeData.length > 0 && !isrefresh) {
          const firstItem = this.treeData[0]
          if (firstItem.children && firstItem.children.length > 0) {
            const firstChild = firstItem.children[0]
            this.selectedCityKey = firstChild.cityCode
            this.$emit('city-selected', firstChild)
          } else {
            this.selectedCityKey = firstItem.cityCode
            this.$emit('city-selected', firstItem)
          }
        }

        this.filteredTreeData = this.searchData()
      }
    },
    /**
     * 选择城市
     * @param {Object} city
     */
    selectCity(city) {
      if (city.children) {
        return
      }
      this.selectedCityKey = city.cityCode
      this.$emit('city-selected', city)
    }
  }
}
</script>

<style lang="less" scoped>
.custom-tree {
  width: 200px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #eee;
  padding: 8px;
  position: relative;

  /deep/ .el-input-group__append {
    padding: 0;
    background: #f3f3f3 !important;

    div {
      padding: 0 16px;
      cursor: pointer;
    }
  }
}

.tree-list {
  height: calc(100vh - 240px);
  overflow-y: auto;
  padding-bottom: 40px;
  box-sizing: border-box;

  .tree-btn {
    padding: 16px;
    width: 100%;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}


.province {
  color: #999;
  font-size: 13px;
}

.province-name {
  font-weight: bold;
  margin-bottom: 2px;
  display: inline-block;
  display: block;
  padding: 8px;
}

.city {
  color: #333;
  font-size: 14px;
  padding: 8px 0 8px 16px;
  cursor: pointer;
}

.active {
  background: #e6f7ff;
  color: #1890ff;
  border-radius: 2px;
}
</style>
